import React from 'react';
import moment from 'moment';

const MiniCalendar = ({ arrivalDate, departureDate }) => {
    if (!arrivalDate || !departureDate) {
        return null;
    }

    const arrival = moment(arrivalDate);
    const departure = moment(departureDate);
    
    // Check if dates are in the same month
    const arrivalMonth = arrival.month();
    const departureMonth = departure.month();
    const arrivalYear = arrival.year();
    const departureYear = departure.year();
    const sameMonth = arrivalMonth === departureMonth && arrivalYear === departureYear;
    
    // Get months to display
    const monthsToShow = [];
    if (sameMonth) {
        monthsToShow.push(arrival.clone().startOf('month'));
    } else {
        // Show both months
        monthsToShow.push(arrival.clone().startOf('month'));
        monthsToShow.push(departure.clone().startOf('month'));
    }

    const isInRange = (day) => {
        if (!day) return false;
        return day.isSameOrAfter(arrival, 'day') && day.isSameOrBefore(departure, 'day');
    };

    const isArrival = (day) => {
        return day && day.isSame(arrival, 'day');
    };

    const isDeparture = (day) => {
        return day && day.isSame(departure, 'day');
    };

    const renderMonth = (startOfMonth) => {
        const endOfMonth = startOfMonth.clone().endOf('month');
        const firstDayOfWeek = startOfMonth.day();
        
        // Get all days in the month
        const days = [];
        for (let i = 0; i < firstDayOfWeek; i++) {
            days.push(null);
        }
        
        let current = startOfMonth.clone();
        while (current.isSameOrBefore(endOfMonth, 'day')) {
            days.push(current.clone());
            current.add(1, 'day');
        }

        return (
            <div key={startOfMonth.format('YYYY-MM')} className="mb-3">
                <div className="card border">
                    <div className="card-header text-center bg-light p-2">
                        <strong className='text-black' style={{ fontSize: '0.9rem' }}>{startOfMonth.format('MMMM YYYY')}</strong>
                    </div>
                    <div className="card-body p-2">
                        {/* Day headers */}
                        <div className="d-flex mb-1">
                            {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((day, index) => (
                                <div key={index} className="text-center" style={{ flex: 1, fontSize: '0.75rem', fontWeight: 'bold', color: '#666' }}>
                                    {day}
                                </div>
                            ))}
                        </div>
                        
                        {/* Calendar days */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px' }}>
                            {days.map((day, index) => {
                                if (!day) {
                                    return <div key={index} style={{ aspectRatio: '1', minHeight: '32px' }}></div>;
                                }
                                
                                const inRange = isInRange(day);
                                const isArr = isArrival(day);
                                const isDep = isDeparture(day);
                                
                                let bgColor = '#fff';
                                let textColor = '#000';
                                let fontWeight = 'normal';
                                
                                if (isArr && isDep) {
                                    bgColor = '#ff9800';
                                    textColor = '#fff';
                                    fontWeight = 'bold';
                                } else if (isArr) {
                                    bgColor = '#28a745';
                                    textColor = '#fff';
                                    fontWeight = 'bold';
                                } else if (isDep) {
                                    bgColor = '#dc3545';
                                    textColor = '#fff';
                                    fontWeight = 'bold';
                                } else if (inRange) {
                                    // Dates between arrival and departure - blue background with white font (like stayover days)
                                    bgColor = '#06A9F4';
                                    textColor = '#fff';
                                    fontWeight = 'bold';
                                }
                                
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            aspectRatio: '1',
                                            minHeight: '32px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: bgColor,
                                            color: textColor,
                                            fontWeight: fontWeight,
                                            fontSize: '0.85rem',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '2px'
                                        }}
                                    >
                                        {day.date()}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="mini-calendar d-lg-flex gap-2" style={{ width: '280px' }}>
            {monthsToShow.map(month => renderMonth(month))}
        </div>
    );
};

export default MiniCalendar;

